(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-section/assets/javascripts/casino-section.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-section/assets/javascripts/casino-section.js');

'use strict';

const {
  CasinoGrid,
  CasinoGridVirtualized,
  CasinoNoSearchResults
} = svs.components.casino_react;
const {
  GridDisplayModes
} = svs.components.casino_react.common.constants;
const {
  CasinoSectionHeader
} = svs.components.casino_react.casinoSection;
const CasinoGamesListComponent = _ref => {
  let {
    isLoading,
    fetchMore,
    displayMode,
    items,
    totalGamesCount
  } = _ref;
  if (fetchMore) {
    return React.createElement(CasinoGridVirtualized, {
      displayMode: displayMode,
      fetchMore: fetchMore,
      isLoading: isLoading,
      items: items,
      totalGamesCount: totalGamesCount
    });
  }
  return React.createElement(CasinoGrid, {
    displayMode: displayMode,
    isLoading: isLoading,
    items: items
  });
};
const CasinoSection = _ref2 => {
  let {
    ActionButtons,
    displayMode,
    fetchMore,
    totalGamesCount,
    isLoading,
    items,
    title,
    isSearchResult = false
  } = _ref2;
  const isListEmpty = !(items !== null && items !== void 0 && items.length);
  const noSearchResult = isListEmpty && !isLoading && isSearchResult;
  return React.createElement("section", {
    className: "casino-section"
  }, React.createElement(CasinoSectionHeader, {
    ActionButtons: ActionButtons,
    title: title
  }), noSearchResult && React.createElement(CasinoNoSearchResults, null), !noSearchResult && React.createElement(CasinoGamesListComponent, {
    displayMode: displayMode,
    fetchMore: fetchMore,
    isListEmpty: isListEmpty,
    isLoading: isLoading,
    isSearchResult: isSearchResult,
    items: items,
    totalGamesCount: totalGamesCount
  }));
};
setGlobal('svs.components.casino_react.casinoSection.CasinoSection', CasinoSection);

 })(window);